import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { ProtectedRoute, AdminRoute } from "@/components/ProtectedRoute";
import { DashboardLayout } from "@/components/Layout/DashboardLayout";

import Landing from "@/pages/Landing";
import Login from "@/pages/auth/Login";
import Signup from "@/pages/auth/Signup";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import AuthCallback from "@/pages/auth/AuthCallback";

import Dashboard from "@/pages/Dashboard";
import FindTravellers from "@/pages/FindTravellers";
import FindDeliveries from "@/pages/FindDeliveries";
import CreateTrip from "@/pages/CreateTrip";
import CreateDelivery from "@/pages/CreateDelivery";
import MyTrips from "@/pages/MyTrips";
import MyDeliveries from "@/pages/MyDeliveries";
import DeliveryDetails from "@/pages/DeliveryDetails";
import Messages from "@/pages/Messages";
import Notifications from "@/pages/Notifications";
import Profile from "@/pages/Profile";
import Safety from "@/pages/Safety";
import Support from "@/pages/Support";
import Settings from "@/pages/Settings";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";

const withLayout = (el) => (
  <ProtectedRoute>
    <DashboardLayout>{el}</DashboardLayout>
  </ProtectedRoute>
);

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ForgotPassword />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />

      <Route path="/dashboard" element={withLayout(<Dashboard />)} />
      <Route path="/find-travellers" element={withLayout(<FindTravellers />)} />
      <Route path="/find-deliveries" element={withLayout(<FindDeliveries />)} />
      <Route path="/create-trip" element={withLayout(<CreateTrip />)} />
      <Route path="/create-delivery" element={withLayout(<CreateDelivery />)} />
      <Route path="/my-trips" element={withLayout(<MyTrips />)} />
      <Route path="/my-deliveries" element={withLayout(<MyDeliveries />)} />
      <Route path="/deliveries/:id" element={withLayout(<DeliveryDetails />)} />
      <Route path="/messages" element={withLayout(<Messages />)} />
      <Route path="/notifications" element={withLayout(<Notifications />)} />
      <Route path="/profile" element={withLayout(<Profile />)} />
      <Route path="/safety" element={withLayout(<Safety />)} />
      <Route path="/support" element={withLayout(<Support />)} />
      <Route path="/settings" element={withLayout(<Settings />)} />
      <Route path="/admin" element={<AdminRoute><DashboardLayout><AdminDashboard /></DashboardLayout></AdminRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
